export interface Orders {
    orders: Order[];
    summary: Summary;
    pagination?: Pagination;
    available_countries?: CurrencySummary[];
  }

export interface Pagination {
    page: number;
    size: number;
    total_items: number;
    total_pages: number;
}

export enum PaymentProvider {
    CONTRA_ENTREGA = "contra_entrega",
    MERCADO_PAGO = "mercadopago",
    STRIPE = "stripe",
    CONFIO = "confio",
    SHOPIFY = "shopify",
}
  
export interface BenefitPurchase {
    label: string;
    name: string;
    price: number;
}

export interface OrderFunnelConfiguration {
    name_funnel?: string | null;
}

export interface LogisticsDecisionSummary {
    carrier_name?: string | null;
    carrier_distribution_company_id?: string | null;
    office_address?: string | null;
    office_city?: string | null;
    office_department?: string | null;
    small_municipality_rule_applied?: boolean | null;
    expensive_shipping_rule_applied?: boolean | null;
    customer_extra_shipping_charge?: string | null;
}

export interface DropiLogisticsSummary {
    status_code?: string | null;
    status_label?: string | null;
    status_source?: string | null;
    dropi_observed_status_normalized?: string | null;
    dropi_has_guide?: boolean | null;
    dropi_order_id?: number | null;
    carrier?: string | null;
    guide_number?: string | null;
    sticker_file?: string | null;
    last_tracking_at?: string | null;
    last_error?: string | null;
    quote_summary?: Record<string, unknown> | null;
    logistics_decision?: LogisticsDecisionSummary | null;
}

export interface Order {
    id: number;
    hash_id: string;
    display_code?: string | null;
    priority: string;
    created_at: string;
    updated_at?: string | null;
    state?: "draft" | "created" | "in_progress" | "finished" | "canceled" | string;
    order_state?: "draft" | "created" | "in_progress" | "finished" | "canceled" | string;
    logistic_state: string;
    payment_method?: "cod" | "online" | string;
    payment_provider?: PaymentProvider;
    payment_state: string;
    total_value: number;
    total_value_usd?: number | null;
    total_value_with_discount: number;
    total_value_with_discount_usd?: number | null;
    total_value_paid?: number | null;
    total_value_paid_usd?: number | null;
    display_total_value?: number | null;
    display_total_value_paid?: number | null;
    display_total_value_with_discount?: number | null;
    display_currency_code?: string | null;
    usd_exchange_rate?: number | null;
    country_code?: string | null;
    currency_code?: string | null;
    customer_name: string;
    customer_las_name: string;
    customer_prefix_phone: string;
    customer_phone: string;
    customer_email: string;
    customer_address: string;
    total_units: number;
    product_summary?: string | null;
    product_names?: string | null;
    products_count?: number | null;
    origin?: string | null;
    tracking_source?: string | null;
    tracking_channel?: string | null;
    channel?: string | null;
    website_id?: string | null;
    website_name?: string | null;
    funnel_name?: string | null;
    configurations?: OrderFunnelConfiguration | null;
    dropi_state?: DropiState;
    dropi_observed_status?: string | null;
    dropi_order_status?: string | null;
    logistics_status_code?: string | null;
    logistics_status_label?: string | null;
    logistics_status_source?: string | null;
    dropi_observed_status_normalized?: string | null;
    dropi_has_guide?: boolean | null;
    dropi_logistics?: DropiLogisticsSummary | null;
    dropi_url?: string;
    mastershop_state?: MastershopState;
    mastershop_integration_error?: string | null;
    mastershop_order_id?: string | null;
    mastershop_synced_at?: string | null;
    shopify_integration_state?: ShopifyState;
    shopify_retry_count?: number;
    shopify_next_retry_at?: string | null;
    shopify_last_error_code?: string | null;
    shopify_currency_mode?: "USD_CONVERSION" | "FUNNEL_CURRENCY" | string | null;
    shopify_original_currency?: string | null;
    shopify_original_total?: number | null;
    shopify_rate_date?: string | null;
    shopify_rate_used?: number | null;
    shopify_currency_sent?: string | null;
    shopify_total_sent?: number | null;
    dropi_integration_error?: string;
    shopify_integration_error?: string;
    shopify_admin_url?: string | null;
    benefit_purchases?: BenefitPurchase[];
    // --- Estado de envío unificado (canónico) ---
    fulfillment_status?: string | null;
    fulfillment_provider?: string | null;
    guide_number?: string | null;
    carrier?: string | null;
    tracking_url?: string | null;
    fulfillment_detail?: string | null;
    fulfillment_raw_status?: string | null;
    fulfillment_event_at?: string | null;
    delivered_at?: string | null;
    estimated_delivery_at?: string | null;
    shipping_cost?: number | null;
    fulfillment_events?: FulfillmentEvent[] | null;
}

export interface FulfillmentEvent {
    mapped_status?: string | null;
    raw_status?: string | null;
    carrier?: string | null;
    guide_number?: string | null;
    tracking_url?: string | null;
    detail?: string | null;
    source?: string | null; // webhook | poll | manual
    event_at?: string | null;
}

export enum DropiState {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    PENDING_SYNC = "PENDING_SYNC",
    WAITING_PAYMENT = "WAITING_PAYMENT",
}

export enum MastershopState {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    PENDING_SYNC = "PENDING_SYNC",
    WAITING_PAYMENT = "WAITING_PAYMENT",
}

export enum ShopifyState {
    PENDING = "PENDING",
    PENDING_RATE = "PENDING_RATE",
    RETRYING = "RETRYING",
    SUCCESS = "SUCCESS",
    ERROR_RETRYABLE = "ERROR_RETRYABLE",
    ERROR_FINAL = "ERROR_FINAL",
    ERROR = "ERROR",
    PENDING_SYNC = "PENDING_SYNC",
}
  
export interface Summary {
    total_buyers: number;
    total_units: number | string;
    total_value: number | string;
    total_value_with_discount: number | string;
    currency_breakdown?: CurrencySummary[];
  }

export interface CurrencySummary {
    country_code?: string | null;
    currency_code?: string | null;
    total_value: number | string;
    total_value_paid?: number | string | null;
    total_value_with_discount: number | string;
}
